export enum PersonalizationSourceTypeEnum {
    SYSTEM = 'SYSTEM_JOURNODEX',
    FALLBACK = 'SYSTEM_DISTRIBUTION_FALLBACK',
    CUSTOM = 'CUSTOM_RECIPIENT',
    ENTITY_VALUE = 'CUSTOM_PROFILE',
}
